module.exports = __webpack_public_path__ + "img/gigawhat-mockup_mac_1.4523bba0.svg";